import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.895 49.135L37.2899 56.2984C43.3479 60.106 51.2556 55.9226 51.5243 48.7678L52.0304 35.3091L52.5365 21.8505C52.8051 14.6956 45.2335 9.93645 38.9072 13.2826L27.0063 19.5778L15.105 25.8741C8.77868 29.2202 8.44218 38.1639 14.4998 41.9727L25.8947 49.1361L25.895 49.135Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTriangle);
export default ForwardRef;
